import { t } from 'i18next'

import { Button } from '~/components/Buttons'

import { useRechargeForm } from '../../../../hooks/useRechargeForm'
import Alerts from '../Alerts'

const FooterRechargeForm = () => {
  const {
    amountStepIsValid,
    formIsReadyToSubmit,
    loadingSubmit: loading
  } = useRechargeForm()

  return (
    <footer className="d-flex flex-column gap-2">
      <Alerts />

      <section className="form-default__buttons">
        <Button
          type="submit"
          text={t('rm:recharge')}
          loading={loading}
          size="large"
          template="primary"
          disabled={!formIsReadyToSubmit || !amountStepIsValid}
        />
      </section>
    </footer>
  )
}

export default FooterRechargeForm
